"use strict";

var _regeneratorRuntime = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebFetcher = void 0;

var http_response_1 = require("../http-response");

var WebFetcher = /*#__PURE__*/function () {
  function WebFetcher() {
    _classCallCheck(this, WebFetcher);
  }

  _createClass(WebFetcher, [{
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function (request) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(window === null || window === undefined)) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Unable to find the fetch method. If the intension is to use the library on different platform than the web, you can implement a IFetcher with node-fetch.");

              case 2:
                _context.t0 = http_response_1.HttpResponse;
                _context.next = 5;
                return fetch(new Request(request.url, {
                  body: request.body,
                  headers: request.headers.toArray(),
                  integrity: request.integrity,
                  keepalive: request.keepalive,
                  method: request.method,
                  mode: request.mode,
                  redirect: request.redirect,
                  referrer: request.referrer,
                  referrerPolicy: request.referrerPolicy,
                  signal: request.signal,
                  window: request.window
                }));

              case 5:
                _context.t1 = _context.sent;
                _context.t2 = request;
                return _context.abrupt("return", new _context.t0(_context.t1, _context.t2));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    })
  }]);

  return WebFetcher;
}();

exports.WebFetcher = WebFetcher;